module.exports={
  "id": "passed-hors-doeuvres",
  "badge": "Foodie favorite",
  "name": "Passed hors d’oeuvres",
  "subtext": "Ready to mingle? Elevate your gathering with these perfect bites.",
  "price": {
    "value": 45.0,
    "per_person": true
  },
  "coverImage": "https://img.peerspace.com/image/upload/v1725383524/jzvgh4ilrk6ccbevz4py.jpg",
  "menu": {
    "subtext": "Serving staff included based on 20 guests. For larger guest counts, the chef will reach out to discuss staff and serving options.",
    "menu_sections": [
      {
        "id": "hors-doeuvres-selections",
        "title": "Select up to 6 options",
        "min_selections": 1,
        "max_selections": 6,
        "items": [
          {
            "name": "Bruschetta with olive tapenade",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Avocado toast crostini",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Feta watermelon skewer",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Deviled eggs",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Summer roll bites with basil, noodles and sweet chili sauce",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Caprese skewer",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Vegetable dumpling with soy dipping sauce",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Stuffed mushroom",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Spanakopita",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Falafel skewer with tzatziki sauce",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Beef meatball",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Chicken Empanada",
            "price": {
              "value": 1.0,
              "per_person": true
            }
          },
          {
            "name": "Pulled pork slider",
            "price": {
              "value": 2.0,
              "per_person": true
            }
          },
          {
            "name": "Yakitori with chicken and soy glaze",
            "price": {
              "value": 2.0,
              "per_person": true
            }
          },
          {
            "name": "Bacon wrapped shrimp",
            "price": {
              "value": 2.0,
              "per_person": true
            }
          },
          {
            "name": "Baby lamb chops",
            "price": {
              "value": 3.0,
              "per_person": true
            }
          },
          {
            "name": "Beef tenderloin bites with red wine sauce",
            "price": {
              "value": 4.0,
              "per_person": true
            }
          },
          {
            "name": "Crème brûlée",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Mini fruit tartlets",
            "price": {
              "value": 0.0
            }
          },
          {
            "name": "Flourless chocolate cake",
            "price": {
              "value": 0.0
            }
          }
        ]
      }
    ]
  },
  "description": "A range of options including: bruschetta with olive tapenade, feta watermelon skewers, vegetable dumplings, bacon wrapped shrimp, beef tenderloin bites, and flourless chocolate cake."
}
